import React, { useEffect } from 'react';
import './styles.scss';
import PropTypes from 'prop-types';
import { noop } from '../../common/propTypes';
import CampaignList from '../../common/CampaignsList';
import LoadingComponent from '../../common/LoadingComponent/';
import { connect } from 'react-redux';
import { getCampaigns, getCampaignsLoading } from './selectors';
import { campaignsRequested } from './actions';
import campaignPropTypes from '../../common/CampaignRow/propTypes';

function Campaigns({ onLoad, campaigns, campaignsLoading }) {
    // use effect is called only when the component mounts
    useEffect(() => {
        window.scrollTo(0, 0);
        onLoad();
    }, []);

    const loader = (
        <div className="challengesLoader">
            <LoadingComponent isLoading={campaignsLoading} />
        </div>
    );

    const renderCampaigns = (campaigns) => {
        return campaigns && campaigns.length ? (
            <CampaignList campaigns={campaigns} />
        ) : (
            <h4 className="text-center">No Campaigns found</h4>
        );
    };

    return (
        <div>
            <h1>Campaigns</h1>
            <div className="col">
                <ul className="list-style">
                    {campaignsLoading ? loader : renderCampaigns(campaigns)}
                </ul>
            </div>
        </div>
    );
}

Campaigns.propTypes = {
    // Function to be called when the Component/Screen loads
    onLoad: PropTypes.func,

    // campaigns to be displayed
    campaigns: PropTypes.arrayOf(
        PropTypes.shape({
            ...campaignPropTypes,
            isGlobal: PropTypes.bool,
            isConnected: PropTypes.bool,
            isActive: PropTypes.bool,
        }),
    ),
    // boolean to represent the screen loading state
    campaignsLoading: PropTypes.bool,
};

Campaigns.defaultProps = {
    onLoad: noop,
    campaigns: [],
    campaignsLoading: false,
};

const mapStateToProps = (state) => {
    return {
        campaigns: getCampaigns(state),
        campaignsLoading: getCampaignsLoading(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onLoad: () => dispatch(campaignsRequested()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Campaigns);
